/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationRule } from './AutomationRule';
import {
    AutomationRuleFromJSON,
    AutomationRuleFromJSONTyped,
    AutomationRuleToJSON,
    AutomationRuleToJSONTyped,
} from './AutomationRule';

/**
 * 
 * @export
 * @interface ListAutomationRulesResponse
 */
export interface ListAutomationRulesResponse {
    /**
     * 
     * @type {Array<AutomationRule>}
     * @memberof ListAutomationRulesResponse
     */
    rules: Array<AutomationRule>;
}

/**
 * Check if a given object implements the ListAutomationRulesResponse interface.
 */
export function instanceOfListAutomationRulesResponse(value: object): value is ListAutomationRulesResponse {
    if (!('rules' in value) || value['rules'] === undefined) return false;
    return true;
}

export function ListAutomationRulesResponseFromJSON(json: any): ListAutomationRulesResponse {
    return ListAutomationRulesResponseFromJSONTyped(json, false);
}

export function ListAutomationRulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAutomationRulesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rules': ((json['rules'] as Array<any>).map(AutomationRuleFromJSON)),
    };
}

export function ListAutomationRulesResponseToJSON(json: any): ListAutomationRulesResponse {
    return ListAutomationRulesResponseToJSONTyped(json, false);
}

export function ListAutomationRulesResponseToJSONTyped(value?: ListAutomationRulesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rules': ((value['rules'] as Array<any>).map(AutomationRuleToJSON)),
    };
}

